import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";
import splashAnimation from "src/assets/animations/sparetime-logo.json";

function SplashScreen() {
  const [onComplete, setOnComplete] = useState(
    typeof localStorage !== "undefined"
      ? localStorage.getItem("splash") === "true"
        ? true
        : false
      : false
  );

  useEffect(() => {
    setTimeout(() => {
      setOnComplete(true);
      localStorage.setItem("splash", "true");
    }, 2700);
  }, []);

  if (onComplete) return null;

  return (
    <div className="absolute z-30 bg-black w-full h-full object-cover inset-0 flex items-center justify-center overflow-hidden">
      <Lottie animationData={splashAnimation} />
    </div>
  );
}

export default SplashScreen;
